import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Heading, Text } from "@nju/ui";

interface Props {
  offerCategory: IMobileOrchestrator["offerCategory"];
}

export function Title({ offerCategory }: Props) {
  const isPostpaid = offerCategory === "MOBILE_POSTPAID";
  return (
    <>
      <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
        <div className="flex gap-2 items-center">
          <Text
            size={{
              "@onlyMobile": "xl",
              "@fromTablet": "keySM",
            }}
            weight="bold"
          >
            nju {isPostpaid ? "abonament" : "subskrypcja"}
          </Text>
          <div className="text-size-14 font-bold text-white bg-daintree w-6 h-6 rounded-[8px] flex justify-center items-center mt-1">
            <span>5G</span>
          </div>
          {isPostpaid && (
            <div className="text-size-14 font-bold text-black bg-ripeLemon w-9 h-6 rounded-[8px] flex justify-center items-center mt-1">
              <span>eSIM</span>
            </div>
          )}
        </div>
      </Heading>
    </>
  );
}
